module.exports = __webpack_public_path__ + "static/media/Term_of_services.49372527.pdf";